import { del, post, put } from 'src/helpers/api'
import { api } from '../api'
import {
  SET_KITTING_LIST_DATA,
  SET_PRODUCT_CATEGORIES_LIST_DATA,
  SET_PRODUCT_DATA,
  SET_PRODUCT_GROUPING_DATA,
  SET_PRODUCT_GROUPING_LIST_DATA,
  SET_PRODUCT_KITTING_DATA,
  SET_PRODUCT_LESS_DATA,
  SET_PRODUCT_LIST_DATA,
  SET_PRODUCT_SEARCH_DATA,
  SET_PWP_FOC_DATA,
  SET_PWP_FOC_LIST_DATA,
  SHOW_NOTIFICATION,
  SET_KITTING_STATS_DATA,
} from 'src/store/types'

export const getProductByIdAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.productById, query)
      .then(response => {
        const json = response.data
        commit(SET_PRODUCT_DATA, {
          data: json,
        })

        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getProductLessByIdAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productLessById, query).then(response => {
      const json = response.data
      commit(SET_PRODUCT_LESS_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const updateStandardProductAction = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    // Remove if parent not selected to avoid validation error
    put(api.productSave + '/' + data.product_id, data)
      .then(response => {
        const json = response.data
        commit(SET_PRODUCT_DATA, {
          data: json,
        })
        commit(SHOW_NOTIFICATION, { title: 'standard.product.setup', message: 'operation.success', type: 'positive' })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getProductListingAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.products, query).then(response => {
      const json = response.data
      commit(SET_PRODUCT_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const getProductSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productSearch, query).then(response => {
      const json = response.data.data
      commit(SET_PRODUCT_SEARCH_DATA, {
        list: json.map(opt => ({ label: opt.sku, value: opt.id, sublabel: opt.name })),
      })

      resolve(response.data)
    })
  })
}

export const getKittingListingAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.kitting, query).then(response => {
      const json = response.data
      commit(SET_KITTING_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const removeUploadedImageAction = ({ commit }, image) => {
  return new Promise(resolve => {
    del(api.productRemoveImageById + '/' + image.id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Deleted', message: 'image.deleted', type: 'positive' })
      resolve(response)
    })
  })
}

export const getKittingProductByIdAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.productKittingById, query)
      .then(response => {
        const json = response.data
        commit(SET_PRODUCT_KITTING_DATA, {
          data: json,
        })

        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const createKittingProductAction = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    // Remove if parent not selected to avoid validation error
    post(api.productKittingSave, data)
      .then(response => {
        commit(SHOW_NOTIFICATION, { title: 'kitting.product.setup', message: 'operation.success', type: 'positive' })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getProductGroupingListingAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productGroupingList, query).then(response => {
      const json = response.data
      commit(SET_PRODUCT_GROUPING_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const createProductGroupingAction = ({ commit }, data) => {
  return new Promise(resolve => {
    // Remove if parent not selected to avoid validation error
    post(api.createProductGrouping, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Product Grouping Setup', message: 'Operation success', type: 'positive' })
      const json = response.data
      commit(SET_PRODUCT_GROUPING_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const getProductGroupingDetailByIdAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.getProductGroupingDetail, query).then(response => {
      const json = response.data
      commit(SET_PRODUCT_GROUPING_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const getProductCategoriesAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productCategories, query).then(response => {
      const json = response.data
      commit(SET_PRODUCT_CATEGORIES_LIST_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const getPwpFocListingAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.pwpFoc, query).then(response => {
      const json = response.data
      commit(SET_PWP_FOC_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const createPwpFocAction = ({ commit }, data) => {
  return new Promise(resolve => {
    // Remove if parent not selected to avoid validation error
    post(api.PwpFocSave, data).then(response => {
      const json = response.data
      commit(SET_PWP_FOC_DATA, {
        data: json,
      })

      commit(SHOW_NOTIFICATION, { title: 'PWP & FOC Setup', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const getKittingSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.kittingSearch, query).then(response => {
      const json = response.data.data
      commit(SET_PRODUCT_SEARCH_DATA, {
        list: json.map(opt => ({ label: opt.code, value: opt.id, sublabel: opt.name })),
      })

      resolve(response.data)
    })
  })
}

export const getPwpFocByIdAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.pwpFocById, query).then(response => {
      const json = response.data
      commit(SET_PWP_FOC_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const getKittingStatsByIdAction = ({ commit }, query) => {
  return new Promise(resolve => {
    if (query) {
      post(api.kittingStatsById, query)
        .then(response => {
          const json = response.data
          commit(SET_KITTING_STATS_DATA, json)

          resolve(response.data)
        })
        .catch(() => {
          commit(SET_KITTING_STATS_DATA, null)
        })
    } else {
      commit(SET_KITTING_STATS_DATA, null)
    }
  })
}

export const resetKittingStatsAction = ({ commit }) => {
  commit(SET_KITTING_STATS_DATA, null)
}
